import cx from 'classnames';
export default function CheckoutActionButton({ children, onClick, className }) {
  return (
    <button
      className={cx(['mt-3 rounded border bg-blue-200 p-2', className])}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
